import { connect } from 'react-redux';

import {
    mapDispatchToProps,
    mapStateToProps,
    ProductCardContainer as SourceProductCardContainer
} from 'SourceComponent/ProductCard/ProductCard.container';
import { showPopup } from 'Store/Popup/Popup.action';
import history from 'Util/History';
import { getBaseImage } from 'Util/Product/Extract';
import getStore from 'Util/Store';
import { appendWithStoreCode, objectToUri } from 'Util/Url';

export {
    mapStateToProps,
    mapDispatchToProps
};

/** @namespace Elganso/Component/ProductCard/Container */
export class ProductCardContainer extends SourceProductCardContainer {
    state = {
        ...this.state,
        isAddingToCart: false,
        actualHoverProductCard: false,
        showRecomendador: false
    };

    containerProps() {
        const { product } = this.props;
        const { isAddingToCart, actualHoverProductCard, showRecomendador } = this.state;

        return {
            ...super.containerProps(),
            thumbnail: getBaseImage(this.getActiveProduct()) || getBaseImage(product),
            preorder: this.isPreorder(),
            isAddingToCart,
            actualHoverProductCard,
            showRecomendador,
            currentDate: new Date()
        };
    }

    containerFunctions = {
        ...this.containerFunctions,
        handleOutOfStockClick: this.handleOutOfStockClick.bind(this),
        hoverProductCard: this.hoverProductCard.bind(this),
        leavehoverProductCard: this.leavehoverProductCard.bind(this),
        showGuiaDeTallas: this.showGuiaDeTallas.bind(this)
    };

    hoverProductCard() {
        const { device } = this.props;

        if (!device.isMobile) {
            this.setState({ actualHoverProductCard: true });
        }
    }

    leavehoverProductCard() {
        const { device } = this.props;

        if (!device.isMobile) {
            this.setState({ actualHoverProductCard: false });
        }
    }

    handleOutOfStockClick(params) {
        const store = getStore();
        const { dispatch } = store;
        dispatch(showPopup(`outofstock-popup-${this.props.product.sku}`, {
            title: __('Pop up fuera de stock'), product: this.props.product, isOutOfStock: 1, params
        }));
    }

    showGuiaDeTallas() {
        const { showRecomendador } = this.state;

        if (showRecomendador) {
            this.setState({ showRecomendador: false });
        } else {
            this.setState({ showRecomendador: true });
        }
    }

    isPreorder() {
        const {
            product: {
                preorder
            }
        } = this.props;
        let isPreOrder = preorder;

        if (this.props.product?.variants) {
            const preOrderItems = this.props.product?.variants.filter((obj) => obj.preorder);
            isPreOrder = preOrderItems.length > 0 ? (preOrderItems.length === this.props.product?.variants.length) : false;
        }

        if (isPreOrder) {
            return isPreOrder;
        }

        return 0;
    }

    getLinkTo() {
        const {
            baseLinkUrl,
            productUsesCategories,
            categoryUrlSuffix,
            product: { url, url_rewrites = [] },
            product
        } = this.props;
        const { pathname: storePrefix } = new URL(baseLinkUrl || window.location.origin);
        const { location: { pathname } } = history;

        if (!url) {
            return undefined;
        }

        let { parameters } = this.state;
        const { state: { category = null } = {} } = history.location;
        const categoryUrlPart = pathname.replace(storePrefix, '').replace(categoryUrlSuffix, '');
        const productUrl = `${categoryUrlPart}/${url.replace(storePrefix, '')}`;

        // if 'Product Use Categories' is enabled then use the current window location to see if the product
        // has any url_rewrite for that path. (if not then just use the default url)
        const rewriteUrl = url_rewrites.find(({ url }) => url.includes(productUrl)) || {};
        let rewriteUrlPath = productUsesCategories
            ? (rewriteUrl.url && appendWithStoreCode(rewriteUrl.url)) || url
            : url;

        if (parameters.color && product.configurable_options.color) {
            const {
                attributes: {
                    default_color: {
                        attribute_value
                    }
                },
                configurable_options,
                variants
            } = product;

            let parameterColor = null;
            // QUITAMOS EL COLOR DE LOS PARAMETROS Y LO ALMACENAMOS
            if ('color' in parameters) {
                // eslint-disable-next-line no-unused-vars
                const { color, ...rest } = parameters;
                parameters = rest;
                parameterColor = color;
            }

            if (configurable_options?.color?.attribute_value && configurable_options?.color?.attribute_value !== attribute_value) {
                const filterProductColor = variants.filter((obj) => obj.attributes.color.attribute_value === configurable_options.color.attribute_value) || [];

                if (filterProductColor.length > 0 && filterProductColor[0].url_key) {
                    rewriteUrlPath = filterProductColor[0].url_key;

                    return {
                        pathname: rewriteUrlPath,
                        state: { prevCategoryId: category },
                        search: objectToUri(parameters)
                    };
                // eslint-disable-next-line no-else-return
                } else {
                    parameters.color = parameterColor;
                }
            }
        }

        return {
            pathname: rewriteUrlPath,
            state: { product, prevCategoryId: category },
            search: objectToUri(parameters)
        };
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductCardContainer);
